import { render, staticRenderFns } from "./ProductConfirmation.vue?vue&type=template&id=99418222&scoped=true&"
import script from "./ProductConfirmation.vue?vue&type=script&lang=js&"
export * from "./ProductConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ProductConfirmation.vue?vue&type=style&index=0&id=99418222&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99418222",
  null
  
)

export default component.exports